import { useTranslation } from 'react-i18next'
import React from 'react'

import { useBtimeLogger } from '../../../utils/logger/btimeLogs/log'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Center from '../../../components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'

const NotFoundPage = () => {
  const { t } = useTranslation('errors')
  const btLogger = useBtimeLogger()

  React.useEffect(() => {
    btLogger.error({ name: 'pageNotFound', data: { url: window?.location?.href } })
  }, [])

  return (
    <AbsoluteWithMenuSpacePageTemplate>
      <Center flex={1} minHeight="100vh">
        <IconBlock icon="BsSearch" title={t('notFound.title')} subtitle={t('notFound.subtitle')} />
      </Center>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default NotFoundPage
